import React from 'react'
import Icon from '../Icon2/Icon'
import Tooltip from '../Tooltip/Tooltip'
// import OutlineTag from '../Tag/OutlineTag'
import DateLabel from '../DateLabel/DateLabel'
import './PublishDetails.css'
import Pill from '../Pills/Pill'
type PublishStatusProps = {
  label?: string
  style?: React.CSSProperties
  className?: string
  details?: React.ReactNode | string | undefined
  color?: string
  environment?: string
  version?: string
  locale?: string
  userName?: string
  scheduledAt?: string
  dateTime?: any
  publishAction?: string
  versionOnClick?: Function
  url?: React.ReactNode | string
  testId?: string
  versionTestId?: string
  showUnlocalizePublish?: boolean
  showActionIcons?: boolean
  onRescheduleClick?: () => void
  onCancelScheduleClick?: () => void
  zone?: string
}
const handleVersionClick = (versionOnClick) => {
  if (versionOnClick) {
    versionOnClick()
  }
}
const GetScheduleInfo = ({
  environment,
  version,
  locale,
  url,
  userName,
  scheduledAt,
  publishAction,
  versionOnClick,
  versionTestId,
  showUnlocalizePublish,
  testId,
  showActionIcons,
  onRescheduleClick,
  onCancelScheduleClick,
  zone
}: PublishStatusProps) => {
  const handleVersionClickOnKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleVersionClick(versionOnClick)
    }
  }
  const currentDate = new Date()
  const scheduleAtDate = scheduledAt ? new Date(scheduledAt) : null
  const scheduledDatePassed = scheduleAtDate && (currentDate > scheduleAtDate)
  return (
    <div>
      <div className="flex-v-center mb-10">
        <div className="PublishDetails__env"
          data-test-id={`${testId}-schedule-env`}
        >{environment}</div>
      </div>
      {version ? (
        <div className="flex-v-center mb-15 VersionDetails">
          <div
            data-test-id={versionTestId}
            onClick={versionOnClick ? () => handleVersionClick(versionOnClick) : null}
            tabIndex={versionOnClick ? 0 : -1}
            onKeyDown={versionOnClick ? handleVersionClickOnKeyDown : null}
            className={`PublishDetails__version ${versionOnClick ? 'PublishDetails__version__link' : ''}`}>
            <span> {version}</span>
          </div>
          <div>
            {/* {publishAction == 'publish' ? <Pill shouldHaveBorder={false} isSortable={false} variant="label" status="default" items={[{ id: 1, text: `${scheduledDatePassed}` ? "Scheduled Publish Failed" : "Scheduled Publish" }]} /> : null} */}
            {publishAction == 'publish' ? <Pill shouldHaveBorder={false} isSortable={false} variant="label" status="default" items={[{ id: 1, text: `${scheduledDatePassed ? "Scheduled Publish Failed" : "Scheduled Publish"}` }]} /> : null}
            {publishAction == 'unpublish' ? <Pill shouldHaveBorder={false} isSortable={false} variant="label" status="default" items={[{ id: 2, text: `${scheduledDatePassed ? "Scheduled Unpublish Failed" : "Scheduled Unpublish"}` }]} /> : null}
            {publishAction == 'scheduled' ? <Pill shouldHaveBorder={false} isSortable={false} variant="label" status="default" items={[{ id: 3, text: `${scheduledDatePassed ? "Scheduled Deploy Failed" : "Scheduled Deploy"}` }]} /> : null}
          </div>
          {showActionIcons && (
            <div className='VersionDetails__action-buttons'>
              <Tooltip content="Reschedule" position="bottom" showArrow={false}>
                <div className='VersionDetails__action-button' onClick={onRescheduleClick}><Icon icon="Reschedule" version="v2" size="small" /></div>
              </Tooltip>
              <Tooltip content="Cancel Scheduling" position="bottom" showArrow={false}>
                <div className='VersionDetails__action-button' onClick={onCancelScheduleClick}><Icon icon="DontSave" version="v2" size="small" /></div>
              </Tooltip>
            </div>
          )}
        </div>
      ) : null}
      {locale && showUnlocalizePublish ? (
        <div className="flex-v-center mb-10">
          <Tooltip content="Locale" position="left" showArrow={false}>
            <Icon icon="Language" size="small" version="v2" />
          </Tooltip>
          <span className="PublishDetails__locale">{locale}</span>
        </div>
      ) : null}
      <div className="flex-v-center mb-10">
        {publishAction === 'publish' || publishAction === 'unpublish' || publishAction === 'scheduled' ? (
          <Tooltip content={scheduledDatePassed ? "Scheduled Time Passed" : `Scheduled to be ${publishAction == 'scheduled' ? 'deploy' : publishAction} on`} position="left" showArrow={false}>
            <Icon icon="Clock" version="v2" size="small" />
          </Tooltip>
        ) : (
          <Tooltip content="Published At" position="left" showArrow={false}>
            <Icon icon="PublishIcon" version="v2" size="small" />
          </Tooltip>
        )}
        <DateLabel zone={zone} date={scheduledAt} className='ml-8' type="medium" />
      </div>
      {(locale && !showUnlocalizePublish) ? (
        <div className="flex-v-center mb-10">
          <Tooltip content="Locale" position="left" showArrow={false}>
            <Icon icon="Language" size="small" version="v2" />
          </Tooltip>
          <span className="PublishDetails__locale"
            data-test-id={`${testId}-schedule-locale`}
          >{locale}</span>
        </div>
      ) : null}
      <div className="flex-v-center mb-10">
        <Tooltip content="User" position="left" showArrow={false}>
          <Icon icon="Profile" version="v2" size="small" />
        </Tooltip>
        <span className="PublishDetails__user"
          data-test-id={`${testId}-schedule-user`}>
          {userName}</span>
      </div>
      {url && (
        <div className="flex-v-center">
          <Tooltip content="Url" position="left" showArrow={false}>
            <Icon icon="Url" version='v2' size='small' />
          </Tooltip>
          <span className="PublishDetails__url">{url || '-'}</span>
        </div>
      )}
      {showUnlocalizePublish && (<GeUnlocalizePublishDetails testId={testId} />)}
    </div>
  )
}
const GetVersionDetails = ({ version, versionOnClick, showActionIcons, onRescheduleClick, onCancelScheduleClick }) => {
  const handleVersionClickOnKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleVersionClick(versionOnClick)
    }
  }
  if (version) {
    return (
      <div className="flex-v-center mb-15 VersionDetails">
        <div
          onClick={versionOnClick ? () => handleVersionClick(versionOnClick) : null}
          className={`PublishDetails__version ${versionOnClick ? 'PublishDetails__version__link' : ''}`}
          tabIndex={versionOnClick ? 0 : -1}
          onKeyDown={versionOnClick ? handleVersionClickOnKeyDown : null}>
          <span> {version}</span>
        </div>
        {showActionIcons && (
          <div className='VersionDetails__action-buttons'>
            <Tooltip content="Reschedule" position="bottom" showArrow={false}>
              <div className='VersionDetails__action-button' onClick={onRescheduleClick}><Icon icon="Reschedule" version="v2" size="small" /></div>
            </Tooltip>
            <Tooltip content="Cancel Scheduling" position="bottom" showArrow={false}>
              <div className='VersionDetails__action-button' onClick={onCancelScheduleClick}><Icon icon="DontSave" version="v2" size="small" /></div>
            </Tooltip>
          </div>
        )}
      </div>
    )
  }
  return null
}
const GeUnlocalizePublishDetails = ({ testId }) => {
  return <div className="flex-v-center">
    <Icon icon="WarningBoldNew" version='v2' size='small' />
    <span className="PublishDetails__unlocalize ml-8" data-test-id={`${testId}-publish-unlocalize`}>Published before localization</span>
  </div>
}
const PublishDetails: React.FunctionComponent<PublishStatusProps> = (props) => {
  const {
    color,
    environment,
    version = "",
    locale = "",
    userName,
    scheduledAt,
    dateTime,
    publishAction,
    versionOnClick,
    url,
    testId = "cs-publish-details",
    showUnlocalizePublish,
    label = '',
    versionTestId = "cs-publish-details-version-test-id",
    showActionIcons = false,
    onRescheduleClick,
    onCancelScheduleClick,
    zone
  } = props
  return (
    <div className="PublishDetails" data-test-id={testId}>
      <div>
        <Icon icon="EnvironmentColor" fill={color}></Icon>
        {scheduledAt ? (
          <GetScheduleInfo zone={zone} testId={testId} versionTestId={versionTestId} {...props} />
        ) : (
          <div>
            <div>
              <div className="PublishDetails__env mb-10" data-test-id={`${testId}-env`}>{environment}</div>
            </div>
            <GetVersionDetails version={version} versionOnClick={versionOnClick} showActionIcons={showActionIcons} onRescheduleClick={onRescheduleClick} onCancelScheduleClick={onCancelScheduleClick} />
            <div className="flex-v-center mb-5">
              <Tooltip content={"Published At"} position="left" showArrow={false}>
                <Icon icon={"PublishIcon"} version="v2" size="small" />
              </Tooltip>
              <DateLabel zone={zone} className='ml-8' date={dateTime} type="medium" dateVal={dateTime}></DateLabel>
            </div>
            <div className="flex-v-center mb-5">
              <Tooltip content="User" position="left" showArrow={false}>
                <Icon icon="Profile" version="v2" size="small" />
              </Tooltip>
              <span className="PublishDetails__user"
                data-test-id={`${testId}-username`}
              >{userName}</span>
            </div>
            {url && (
              <div className="flex-v-center">
                <Tooltip content="Url" position="left" showArrow={false}>
                  <Icon icon="Url" version='v2' size='small' />
                </Tooltip>
                <span className="PublishDetails__url">{url || '-'}</span>
              </div>
            )}
            {showUnlocalizePublish && (<GeUnlocalizePublishDetails testId={testId} />)}
          </div>
        )}
      </div>
    </div>
  )
}

export default PublishDetails
